import { Signal } from '@angular/core';
import { Observable } from 'rxjs';
import { toSignal as toSignalInterop } from '@angular/core/rxjs-interop';

/**
 * Converts an RxJS Observable into an Angular Signal.
 *
 * Wraps Angular's `toSignal` from `@angular/core/rxjs-interop`, simplifying the
 * API by accepting the initial value as a direct parameter rather than an options
 * object.
 *
 * @param observable The source Observable to convert into a Signal.
 * @param initialValue Optional value the Signal holds before the Observable emits.
 * @returns A read-only Signal that reflects the latest emission from the Observable.
 */
// eslint-disable-next-line no-redeclare
export function toSignal<T>(observable: Observable<T>): Signal<T | undefined>;
// eslint-disable-next-line no-redeclare
export function toSignal<T, U extends T>(
  observable: Observable<T>,
  initialValue: U
): Signal<T | U>;
// eslint-disable-next-line no-redeclare
export function toSignal<T>(
  observable: Observable<T>,
  initialValue?: T
): Signal<T | undefined> {
  if (initialValue === undefined) {
    return toSignalInterop(observable);
  }

  return toSignalInterop(observable, { initialValue: initialValue as T });
}
